import { Component, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { InputType } from 'enums/InputType';
import { NavigationService } from 'services/navigation.service';

@Component({
	selector: 'unsuspend-accounting-plan-confirm',
	templateUrl: './unsuspend-accounting-plan-confirm.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, CustomSelectComponent, TranslatePipe]
})
export class UnsuspendAccountingPlanConfirmComponent {

	inputTypeEnum = InputType;
	deleteInvoices?: number;

	deleteInvoicesSelect: SelectListItemModel[] = [];

	@Output() public confirmEvent = new EventEmitter<boolean>();

	constructor(protected readonly navigation: NavigationService, private readonly translate: TranslatePipe) {
		this.deleteInvoicesSelect.push(new SelectListItemModel(0, this.translate.transform('general.false')));
		this.deleteInvoicesSelect.push(new SelectListItemModel(1, this.translate.transform('general.true')));
	}

	confirm() {
		this.confirmEvent.emit(this.deleteInvoices == 1);
	}

	close() {
		this.navigation.closeView(this);
	}
}
